import React from "react";
import { Button } from "@/components/ui/button";
import { openExternalUrl } from "@/hooks/useExternalLink";
import Reveal from "./Reveal";

const STORE_URL = "https://theventapp.myshopify.com";

const products = [
  {
    title: "You Are So Loved Signature Tee",
    href: `${STORE_URL}/products/you-are-so-loved-signature-tee-black`,
    image:
      "https://cdn.shopify.com/s/files/1/0751/0894/1902/files/147f38fd4b9d9db774ddccebe4bd.webp?v=1788048817",
  },
  {
    title: "Classic Vent T-Shirt — White",
    href: `${STORE_URL}/products/classic-vent-t-shirt-white`,
    image:
      "https://cdn.shopify.com/s/files/1/0751/0894/1902/files/0e005f054e50b381d7dc39aad7e1.png?v=1788048476",
  },
  {
    title: "Classic Vent T-Shirt — Black",
    href: `${STORE_URL}/products/classic-vent-t-shirt-black`,
    image:
      "https://cdn.shopify.com/s/files/1/0751/0894/1902/files/951e448b4a5887fd9fae2c9503a4.webp?v=1788048211",
  },
];

const StoreSection = () => (
  <section className="py-24 md:py-32" aria-labelledby="store-heading">
    <div className="mx-auto max-w-7xl px-5 md:px-10 grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
      <Reveal>
        <p className="font-display uppercase tracking-[0.3em] text-xs text-brand">Vent Apparel</p>
        <h2
          id="store-heading"
          className="mt-4 font-display uppercase text-4xl md:text-6xl leading-[0.95] tracking-tight text-foreground"
        >
          Wear The Message
        </h2>
        <p className="mt-5 max-w-md text-base md:text-lg leading-relaxed text-muted-foreground">
          Simple pieces carrying simple reminders. Every shirt is a small way to keep the
          conversation going out in the world.
        </p>
        <Button
          size="lg"
          variant="outline"
          onClick={() => openExternalUrl(STORE_URL)}
          className="mt-8 rounded-full px-7 transition-transform duration-300 hover:-translate-y-0.5"
        >
          Shop The Collection
        </Button>
      </Reveal>

      <Reveal delay={100} className="grid grid-cols-2 gap-4 sm:gap-6">
        {products.map((product, i) => (
          <button
            key={product.title}
            type="button"
            onClick={() => openExternalUrl(product.href)}
            className={`group text-left ${i === 0 ? "col-span-2" : ""}`}
          >
            <div
              className={`overflow-hidden rounded-lg bg-paper ${
                i === 0 ? "aspect-square" : "aspect-square"
              }`}
            >
              <img
                src={product.image}
                alt={product.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]"
              />
            </div>
            <p className="mt-3 text-sm text-muted-foreground">{product.title}</p>
          </button>
        ))}
      </Reveal>
    </div>
  </section>
);

export default StoreSection;
